let faqQuestions = document.querySelectorAll(".faq-section-content-question");

for (let i = 0; i < faqQuestions.length; i++) {
  faqQuestions[i].addEventListener('click', () => {
    if(faqQuestions[i].parentNode.querySelector(".faq-section-content-answer").classList.contains("active")){
      faqQuestions[i].parentNode.querySelector(".faq-section-content-answer").classList.remove("active");
    } else {
      faqQuestions[i].parentNode.querySelector(".faq-section-content-answer").classList.add("active");
    }
  })
}